/**
 * webhookPayloads.js — a referência de payloads do webhook de cancela
 * CI Sistemas de Informática Ltda. — AcessoiD
 *
 * Onda 100: saiu de `pages/Settings.js` por script, sem redigitação.
 */
export const WEBHOOK_PAYLOADS = {
  estacionamento: [
    {
      title: 'Entrada de Veículo Avulso',
      event: 'barrier_control',
      reason: 'avulso_entrada',
      desc: 'Disparado quando um veículo avulso (não cadastrado) é detectado na câmera de entrada.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'ABC1D23',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.97,
        timestamp: '2026-05-27T14:30:00.000Z',
        ticket_id: 42,
        vehicle_type: 'avulso',
        reason: 'avulso_entrada',
      }
    },
    {
      title: 'Saída de Veículo Avulso (Câmera Única — Baixa Automática)',
      event: 'barrier_control',
      reason: 'avulso_camera_unica',
      desc: 'Disparado na saída de veículo avulso com Modo Câmera Única ativo. O sistema identificou que havia ticket ativo e registrou a saída automaticamente com baixa automática.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'ABC1D23',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.97,
        timestamp: '2026-06-10T18:30:00.000Z',
        ticket_id: 42,
        vehicle_type: 'avulso',
        single_camera_mode: true,
        reason: 'avulso_camera_unica',
        duration_minutes: 95,
        calculated_amount: 12.00,
        payment_method: 'auto_dinheiro',
        price_table: 'Tabela Padrão',
      }
    },
    {
      title: 'Saída de Veículo Avulso (Modo Paralelo)',
      event: 'barrier_control',
      reason: 'avulso_modo_paralelo',
      desc: 'Disparado na saída de veículo avulso com Modo Paralelo ativo. Inclui o valor calculado automaticamente.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'ABC1D23',
        camera_id: 2,
        camera_name: 'CAM02Saida',
        camera_type: 'saida',
        confidence: 0.94,
        timestamp: '2026-05-27T16:45:00.000Z',
        ticket_id: 42,
        vehicle_type: 'avulso',
        reason: 'avulso_modo_paralelo',
        duration_minutes: 135,
        calculated_amount: 18.00,
        payment_method: 'auto_dinheiro',
        price_table: 'Tabela Padrão',
      }
    },
    {
      title: 'Saída de Veículo Avulso (Pago no Caixa)',
      event: 'barrier_control',
      reason: 'avulso_saida',
      desc: 'Disparado na saída de veículo avulso após pagamento registrado no PDV.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'ABC1D23',
        camera_id: 2,
        camera_name: 'CAM02Saida',
        camera_type: 'saida',
        confidence: 0.91,
        timestamp: '2026-05-27T16:45:00.000Z',
        ticket_id: 42,
        vehicle_type: 'avulso',
        reason: 'avulso_saida',
        duration_minutes: 135,
      }
    },
    {
      title: 'Entrada de Mensalista',
      event: 'barrier_control',
      reason: 'mensalista_entrada',
      desc: 'Disparado quando um mensalista ativo é detectado na câmera de entrada.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'XYZ9A87',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.99,
        timestamp: '2026-05-27T08:15:00.000Z',
        ticket_id: 101,
        vehicle_type: 'mensalista',
        reason: 'mensalista_entrada',
        customer_name: 'João da Silva',
        plan_name: 'Mensalidade Padrão',
      }
    },
    {
      title: 'Saída de Mensalista',
      event: 'barrier_control',
      reason: 'mensalista_saida',
      desc: 'Disparado quando um mensalista é detectado na câmera de saída.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'XYZ9A87',
        camera_id: 2,
        camera_name: 'CAM02Saida',
        camera_type: 'saida',
        confidence: 0.98,
        timestamp: '2026-05-27T18:30:00.000Z',
        ticket_id: 101,
        vehicle_type: 'mensalista',
        reason: 'mensalista_saida',
        customer_name: 'João da Silva',
        plan_name: 'Mensalidade Padrão',
      }
    },
    {
      title: 'Entrada de Credenciado',
      event: 'barrier_control',
      reason: 'credenciado_entrada',
      desc: 'Disparado quando um credenciado ativo é detectado na câmera de entrada.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'MED1234',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.96,
        timestamp: '2026-05-27T07:00:00.000Z',
        ticket_id: 55,
        vehicle_type: 'credenciado',
        reason: 'credenciado_entrada',
        customer_name: 'Dra. Maria Oliveira',
        category: 'medico',
      }
    },
    {
      title: 'Acesso Negado (Fora do Horário)',
      event: 'access_denied',
      reason: 'fora_horario_credenciado',
      desc: 'Disparado quando um credenciado ou mensalista tenta acessar fora do horário permitido. A cancela NÃO é aberta.',
      payload: {
        event: 'access_denied',
        action: 'deny',
        plate: 'MED1234',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.95,
        timestamp: '2026-05-27T23:30:00.000Z',
        reason: 'fora_horario_credenciado',
        customer_name: 'Dra. Maria Oliveira',
      }
    },
  ],
  condominio: [
    {
      title: 'Entrada de Morador',
      event: 'barrier_control',
      reason: 'morador_entrada',
      desc: 'Disparado quando um veículo cadastrado como morador é detectado na entrada.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'RES1234',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.98,
        timestamp: '2026-05-27T19:00:00.000Z',
        ticket_id: 200,
        vehicle_type: 'morador',
        reason: 'morador_entrada',
        customer_name: 'Carlos Pereira',
        unit: 'Apto 301 — Bloco B',
      }
    },
    {
      title: 'Entrada de Visitante Autorizado',
      event: 'barrier_control',
      reason: 'visitante_autorizado',
      desc: 'Disparado quando um visitante com autorização vigente é detectado na entrada.',
      payload: {
        event: 'barrier_control',
        action: 'open',
        plate: 'VIS5678',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.93,
        timestamp: '2026-05-27T14:00:00.000Z',
        ticket_id: 201,
        vehicle_type: 'visitante',
        reason: 'visitante_autorizado',
        customer_name: 'Ana Lima (Visitante)',
        authorized_by: 'Carlos Pereira — Apto 301',
        valid_until: '2026-05-27',
      }
    },
    {
      title: 'Acesso Negado — Veículo Não Cadastrado',
      event: 'access_denied',
      reason: 'veiculo_nao_cadastrado',
      desc: 'Disparado quando um veículo não está cadastrado como morador nem como visitante autorizado.',
      payload: {
        event: 'access_denied',
        action: 'deny',
        plate: 'DES9999',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.91,
        timestamp: '2026-05-27T22:00:00.000Z',
        reason: 'veiculo_nao_cadastrado',
      }
    },
    {
      title: 'Acesso Negado — Visitante com Autorização Expirada',
      event: 'access_denied',
      reason: 'visitante_expirado',
      desc: 'Disparado quando um visitante tenta acessar após o período de autorização.',
      payload: {
        event: 'access_denied',
        action: 'deny',
        plate: 'VIS5678',
        camera_id: 1,
        camera_name: 'CAM01Entrada',
        camera_type: 'entrada',
        confidence: 0.90,
        timestamp: '2026-05-28T10:00:00.000Z',
        reason: 'visitante_expirado',
        customer_name: 'Ana Lima (Visitante)',
      }
    },
  ]
};
